<template>
	<div>
		<Breadcrumbs main="Accounts" title="Edit Vehicle" />
			<div class="container-fluid">
				<div class="row">

                    <div class="col-sm-12">
                        <div class="card">
                            <div class="card-body">
    
                                <div class="row mb-3">
                                    <div class="col-12">
                                        <h4><i class="icofont icofont-plus-circle"></i>&nbsp;Edit Vehicle</h4>
                                    </div>
                                </div>

								<div class="row mb-3">
                                    <div class="col-12">
                                        <h4>Vehicle Details<span class="text-dark">*</span></h4>
                                    </div>
                                </div>
    
                                <form @submit.prevent="updateVehicle" enctype="multipart/form-data">
                                    <div class="form theme-form">

                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">IMEI <span class="text-danger">*</span></label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" placeholder="" v-model="vehicle.imei" disabled/>
                                                
                                            </div>
                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Vehicle Number <span class="text-danger">*</span></label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" placeholder="" v-model="vehicle.vehicle_number" v-bind:class="{ 'is-invalid': Boolean(errors.vehicle_number) }"/> 
                                            </div>
                                            <div v-for="(val, index) in errors.vehicle_number" :key="index" class="invalid-feedback">
                                                    <p class="mb-0">{{ val }}</p>
                                            </div> 
                                        </div>
        
                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Company <span class="text-danger">*</span></label>
                                            </div>
                                            <div class="col-lg-9">
                                                <select class="form-select" v-model="vehicle.company_id">
                                                    <option value="">--select--</option>
                                                    <option :value="company.id" v-for="company in companies" :key="company.id">
                                                        {{company.company_name}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Chasis Number</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" placeholder="" v-model="vehicle.chassis_number"/>
                                            </div>
                                        </div>
        
                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Engine Number</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" placeholder="" v-model="vehicle.engine_number"/>
                                                
                                            </div>
                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Vehicle Make</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" placeholder="" v-model="vehicle.vehicle_make"/>
                                                
                                            </div>
                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Vehicle Model</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" placeholder="" v-model="vehicle.vehicle_model"/>
                                                
                                            </div>
                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Odometer Number <span class="text-danger">*</span></label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" placeholder="" v-model="vehicle.odometer"/>
                                                
                                            </div>
                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">No Software <span class="text-danger">*</span></label>
                                            </div>
                                            <div class="col-lg-9">
                                                <select class="form-select" v-model="vehicle.no_software">
                                                    <option value="0">--Yes--</option>
                                                    <option value="1">--No--</option>
                                                </select>
                                            </div>
                                        </div>

										<div class="row mb-3 mt-5">
											<div class="col-12">
												<h4>Device Details<span class="text-dark">*</span></h4>
											</div>
										</div>

                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Invoice Number</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" placeholder="" v-model="vehicle.invoice_number"/>
                                            </div>
                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Installation Date </label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="date" placeholder="" v-model="vehicle.installation_date"/>
                                            </div>
                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Vehicle Image</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input ref="fileinput" type="file" accept="image/*" class="form-control image-class"/>
                                            </div>
                                        </div>

										<div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Device Image</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input ref="fileinput" type="file" accept="image/*" class="form-control image-class"/>
                                            </div>
                                        </div>

										<div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Certificate Image</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input ref="fileinput" type="file" accept="image/*" class="form-control image-class" />
                                            </div>
                                        </div>

										<div class="row mb-3 mt-5">
											<div class="col-12">
												<h4>Installer Details<span class="text-dark">*</span></h4>
											</div>
										</div>

										<div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Dealer Name</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" placeholder="" v-model="vehicle.dealer_name"/>
                                                
                                            </div>
                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Dealer Address</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <textarea class="form-control" type="text" placeholder="" v-model="vehicle.dealer_address"></textarea>
                                                
                                            </div>
                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Technician Name</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" placeholder="" v-model="vehicle.technician_name"/>
                                                
                                            </div>
                                        </div>

										<div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Technician Mobile</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" placeholder="" v-model="vehicle.technician_mobile" v-mobile-limit maxlength="10" minlength="10" />
                                                
                                            </div>
                                        </div>

										<div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">RTO Trade Certificate Number</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" placeholder="" v-model="vehicle.rto_trade_certificate_number"/>
                                                
                                            </div>
                                        </div>

										<div class="row mb-3 mt-5">
											<div class="col-12">
												<h4>Other Details<span class="text-dark">*</span></h4>
											</div>
										</div>

                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Rc Number</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" placeholder="" v-model="vehicle.rc_number"/>
                                                
                                            </div>
                                        </div>

										<div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Policy Number</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" placeholder="" v-model="vehicle.policy_number"/>
                                                
                                            </div>
                                        </div>

										<div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Tax Number</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" placeholder="" v-model="vehicle.tax_number"/>
                                                
                                            </div>
                                        </div>

										<div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Permit Number</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" placeholder="" v-model="vehicle.permit_number"/>
                                                
                                            </div>
                                        </div>

										<div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Rc Renewal Date</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="date" placeholder="" v-model="vehicle.rc_renewal_date"/>
                                                
                                            </div>
                                        </div>

										<div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Tax Renewal Date</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="date" placeholder="" v-model="vehicle.tax_renewal_date"/>
                                                
                                            </div>
                                        </div>

										<div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Permit Renewal Date</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="date" placeholder="" v-model="vehicle.permit_renewal_date"/>
                                                
                                            </div>
                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Insurance Renewal Date</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="date" placeholder="" v-model="vehicle.insurance_renewal_date"/>
                                                
                                            </div>
                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Pollution Renewal Date</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="date" placeholder="" v-model="vehicle.pollution_renewal_date"/>
                                                
                                            </div>
                                        </div>

										<div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Years for certificate Expiry<span class="text-danger">*</span></label>
                                            </div>
                                            <div class="col-lg-9">
                                                <select class="form-select" v-model="vehicle.years_certificate_expiry">
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-lg-3">
                                                <label class="control-label">Vehicle Type</label>
                                            </div>
                                            <div class="col-lg-9">
                                                <select class="form-select" v-model="vehicle.vehicle_type_id">
                                                    <option value="">--select vehicle type--</option>
                                                    <option value="1">Car</option>
                                                    <option value="2">Truck</option>
													<option value="3">Trailer</option>
													<option value="4">Bus</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row mt-4">
                                            <div class="col-sm-12">
                                                <button class="btn btn-success float-end" type="submit" :disabled="submitting">
                                                    <span v-if="submitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    {{ submitting ? "Saving..." : "Save" }}
                                                </button>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                    
				</div>
			</div>
 
	</div>
</template>

<script>
	export default {
		name: "Organization Page",
		

		data() {
			return {
				
				modal_title: "Add Course",
				button_title: "Add",
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				submitting: false,
				errors: {},
				course: "",

                button_title: "Save",

                companies: [],
                
                vehicle: {

                    imei: "",
                    uin: "",
                    vehicle_number: "",
                    company_id:"" ,
                    chassis_number: "",
                    engine_number: "",
                    vehicle_make: "",
                    vehicle_model: "",
                    odometer: "",
                    no_software:"" ,
                    invoice_number: "",
                    installation_date: "",
                    dealer_name: "",
                    dealer_address: "",
                    technician_name: "",
                    technician_mobile: "",
                    rto_trade_certificate_number: "",
                    rc_number: "",
                    policy_number: "",
                    tax_number: "",
                    permit_number: "",
                    rc_renewal_date: "",
                    tax_renewal_date: "",
                    permit_renewal_date: "",
                    insurance_renewal_date: "",
                    pollution_renewal_date: "",
                    years_certificate_expiry: "",
                    vehicle_type_id: "",
                    device_image: "",
                    vehicle_image: "",
                    certificate_image: "",
                },

                vehicle_image: "",
                preview_image: "",
				
                device_image: "",
			    DevicePreview_image: "",

                certificate_image: "",
			    certificatePreview_image: "",
				
         		// delete: false,
         		// active_page_url: null,
			};
		},

		created() {
             this.fetchCompanies();
            this.vehicleDetail();
           
		},

		methods: 
        {
            getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

            vehicleDetail(page_url = null) {
				this.getToken();
				let url = '/staffs/vehicleDetail?vehicle_id=' + this.$route.params.id;
				page_url = page_url || url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.vehicle = responseData.vehicle;
					})
					.catch((err) => console.log(err));
			},

            fetchCompanies() {
				this.getToken();
				this.$axios
					.get("/staffs/companies", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.companies = responseData.data;
						console.log(this.types);
					})
					.catch((err) => console.log(err));
			},

             setFile(e) {
                this.vehicle_image = e.target.files[0];
                this.preview_image = URL.createObjectURL(e.target.files[0]);
            },

            setDeviceFile(e) {
                this.device_image = e.target.files[0];
                this.DevicePreview_image = URL.createObjectURL(e.target.files[0]);
            },

            setCertificateFile(e) {
                this.certificate_image = e.target.files[0];
                this.certificatePreview_image = URL.createObjectURL(e.target.files[0]);
            },

            updateVehicle() {
				if (this.submitting) return;

                this.getToken();
                this.errors = {};

                const config = {
                    headers: {
                        "Content-type": "multipart/form-data",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                    },
                };

                let url = "staffs/updateVehicle";  
                this.submitting = true;

                let formData = new FormData();
                formData.append("vehicle_id", this.$route.params.id);
                formData.append("imei", this.vehicle.imei);
                formData.append("vehicle_number", this.vehicle.vehicle_number);
                formData.append("company_id", this.vehicle.company_id);
                formData.append("vehicle_make", this.vehicle.vehicle_make);
                formData.append("vehicle_model", this.vehicle.vehicle_model);
                formData.append("odometer", this.vehicle.odometer);
                formData.append("no_software", this.vehicle.no_software);

                if(this.vehicle.chassis_number) {
                    formData.append("chassis_number", this.vehicle.chassis_number);
                } else {
                    formData.append("chassis_number", '');
                }

                if(this.vehicle.engine_number) {
                    formData.append("engine_number", this.vehicle.engine_number);
                } else {
                    formData.append("engine_number", '');
                }

                if(this.vehicle.rto_trade_certificate_number) {
                    formData.append("rto_trade_certificate_number", this.vehicle.rto_trade_certificate_number);
                } else {
                    formData.append("rto_trade_certificate_number", '');
                }

                if(this.vehicle.invoice_number) {
                    formData.append("invoice_number", this.vehicle.invoice_number);
                } else {
                    formData.append("invoice_number", '');
                }

                if(this.vehicle.installation_date) {
                    formData.append("installation_date", this.vehicle.installation_date);
                } else {
                    formData.append("installation_date", '');
                }

                if(this.vehicle.tax_renewal_date) {
                    formData.append("tax_renewal_date", this.vehicle.tax_renewal_date);
                } else {
                    formData.append("tax_renewal_date", '');
                }

                if(this.vehicle.rc_renewal_date) {
                    formData.append("rc_renewal_date", this.vehicle.rc_renewal_date);
                } else {
                    formData.append("rc_renewal_date", '');
                }

                if(this.vehicle.permit_renewal_date) {
                    formData.append("permit_renewal_date", this.vehicle.permit_renewal_date);
                } else {
                    formData.append("permit_renewal_date", '');
                }

                if(this.vehicle.insurance_renewal_date) {
                    formData.append("insurance_renewal_date", this.vehicle.insurance_renewal_date);
                } else {
                    formData.append("insurance_renewal_date", '');
                }

                if(this.vehicle.pollution_renewal_date) {
                    formData.append("pollution_renewal_date", this.vehicle.pollution_renewal_date);
                } else {
                    formData.append("pollution_renewal_date", '');
                }

                if(this.vehicle.years_certificate_expiry) {
                    formData.append("years_certificate_expiry", this.vehicle.years_certificate_expiry);
                } else {
                    formData.append("years_certificate_expiry", '');
                }

                if(this.vehicle.rc_number) {
                    formData.append("rc_number", this.vehicle.rc_number);
                } else {
                    formData.append("rc_number", '');
                }

                formData.append("dealer_name", this.vehicle.dealer_name);
                formData.append("dealer_address", this.vehicle.dealer_address);
                formData.append("technician_name", this.vehicle.technician_name);
                formData.append("technician_mobile", this.vehicle.technician_mobile);
                formData.append("policy_number", this.vehicle.policy_number);
                formData.append("tax_number", this.vehicle.tax_number);
                formData.append("permit_number", this.vehicle.permit_number);
                // formData.append("rc_renewal_date", this.vehicle.rc_renewal_date);
                // formData.append("tax_renewal_date", this.vehicle.tax_renewal_date);
                // formData.append("permit_renewal_date", this.vehicle.permit_renewal_date);
                // formData.append("insurance_renewal_date", this.vehicle.insurance_renewal_date);
                // formData.append("pollution_renewal_date", this.vehicle.pollution_renewal_date);
                if(this.vehicle.vehicle_type_id) {
                    formData.append("vehicle_type_id", this.vehicle.vehicle_type_id);
                } else {
                    formData.append("vehicle_type_id", '');
                }
                formData.append("vehicle_image", this.vehicle_image);
                formData.append("device_image", this.device_image);
                formData.append("certificate_image", this.certificate_image);

                    this.$axios
                    .post(url, formData, config)
                    .then((response) => {
                        if (response.data.status) {
                            this.$swal("", response.data.message, "success");
                        } else {
                            this.$swal("", response.data.message, "error");
                        }
                        this.clearForm();
                        this.$router.push({ name: 'view_vehicles' })
                    })
                    .catch((error) => {
                        console.log(error);
                        console.log(error.response);
                        if (error.response) {
                            if (error.response.data.message) {
                                this.errors = error.response.data.message;
                                this.$swal("", error.response.data.message, "error");
                            } else {
                                this.$swal("", "Something went wrong", "error");
                            }
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    })
					.finally(() => {
						this.submitting = false;
					});
            },

            clearForm() {
                this.imei= "";
                this.vehicle_number= "";
                this.company_id= "";
                this.chassis_number= "";
                this.engine_number= "";
                this.vehicle_make= "";
                this.vehicle_model= "";
                this.odometer= "";
                this.no_software= "";
                this.invoice_number= "";
                this.installation_date= "";
                this.dealer_name= "";
                this.dealer_address= "";
                this.technician_name= "";
                this.technician_mobile= "";
                this.rto_trade_certificate_number= "";
                this.rc_number= "";
                this.policy_number= "";
                this.tax_number= "";
                this.permit_number= "";
                this.rc_renewal_date= "";
                this.tax_renewal_date= "";
                this.permit_renewal_date= "";
                this.insurance_renewal_date= "";
                this.pollution_renewal_date= "";
                this.years_certificate_expiry= "",
                this.vehicle_type_id= "";

                this.errors = {};
            }
		

            
		},
	};
</script>